import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredUtmParams, upsertUtmCookieFromSearch } from '@/lib/utm';
import { getAcquisitionProperties } from '@/lib/acquisition';
import { posthog } from 'posthog-js';

export const UtmCookieManager: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // Suppress remotely configured surveys on the uninterrupted LT checkout.
        posthog.set_config({ disable_surveys: location.pathname === '/lt-checkout', disable_surveys_automatic_display: location.pathname === '/lt-checkout' });
        const updatedParams = upsertUtmCookieFromSearch(location.search);
        const paramsToRegister = updatedParams || getStoredUtmParams();

        if (paramsToRegister && Object.keys(paramsToRegister).length && posthog?.register) {
            posthog.register({ utm_source: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '', ...paramsToRegister });
        }
        posthog.register(getAcquisitionProperties());
    }, [location.pathname, location.search]);

    return null;
};

export default UtmCookieManager;
